<template>
  <div class="people-aside-container">
<!--    <b-modal-->
<!--      modal-class="padding-top_modal-form"-->
<!--      ignore-enforce-focus-selector=".header"-->
<!--      no-close-on-backdrop-->
<!--      no-close-on-esc-->
<!--      hide-header-->
<!--      hide-footer-->
<!--      dialog-class="app__add-friend-modal"-->
<!--      body-class="app__modal_body app__add-friend-modal_body"-->
<!--      content-class="modal_content"-->
<!--      id="add-friend">-->
<!--      <add-friend-form/>-->
<!--    </b-modal>-->
    <aside
      v-if="(isMobile && !showProfile) || (!isMobile)"
      class="people-aside">
      <title-add
        modal="add-friend"
        class="people-aside__title-add"
        :title="$t('CP.people')"/>
      <search-input
        :placeholder="$t('searchInput.placeholderSearch')"
        @search="(search) => searchText = search"
      />
      <sort-list
        class="sort-list"
        @sortBy="(condition) => sortCondition = condition"
        :sort-condition="sortCondition"
        :sort-variants="sortVariants"
        @filterBy="(condition) => filterCondition = condition"
        :filter-condition="filterCondition"
        :filter-variants="filterVariants"
      />
      <people-list
        class="people-list"
        :currency="userPayoutsCurrency"
        @selectUser="selectUser"
        @deleteUser="confirmDeleteUser"
        message="show all"
        :active-user="activeUser"
        :show-delete-button="true"
        :enable-access-check="false"
        :check-user-amount="true"
        :check-user-events-for-delete="true"
        :show-add-button="false"
        :users="filteredUsers || []"
      />
    </aside>
    <b-sidebar
      ref="peopleSidebar"
      id="people-sidebar"
      no-header
      sidebar-class="people-sidebar"
      backdrop
      shadow
    >
      <aside
        v-if="(isMobile && !showProfile) || (!isMobile)"
        class="people-aside_mobile">
        <title-add
          modal="add-friend"
          class="people-aside__title-add"
          :title="$t('CP.people')"/>
        <search-input
          :placeholder="$t('searchInput.placeholderSearch')"
          @search="(search) => searchText = search"
        />
        <sort-list
          class="sort-list"
          @sortBy="(condition) => sortCondition = condition"
          :sort-condition="sortCondition"
          :sort-variants="sortVariants"
          @filterBy="(condition) => filterCondition = condition"
          :filter-condition="filterCondition"
          :filter-variants="filterVariants"
        />
        <people-list
          class="people-list"
          :currency="userPayoutsCurrency"
          @selectUser="selectUser"
          @deleteUser="deleteUser"
          message="show all"
          :active-user="activeUser"
          :show-delete-button="true"
          :enable-access-check="false"
          :check-user-amount="true"
          :check-user-events-for-delete="true"
          :show-add-button="false"
          :users="filteredUsers || []"
        />
      </aside>
    </b-sidebar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  SET_PAYOUTS_ACTIVE_USER,
  USER_PAYOUTS_REQUEST,
} from '@/store/events/types';
import {
  DELETE_USER_CONTACT_REQUEST,
  FETCH_USER_CONTACTS_REQUEST,
} from '@/store/user/types';

import { SET_CONFIRM_MODAL_INFO } from '@/store/operations/types';
import TitleAdd from '../../components/TitleAdd/TitleAdd';
import SearchInput from '../../components/SearchInput/SearchInput';
import SortList from '../../components/SortList/SortList';
import PeopleList from '../../components/PeopleList/PeopleList';
// import AddFriendForm from '../../forms/AddFriendForm/AddFriendForm';

export default {
  name: 'PeopleAside',
  components: {
    // AddFriendForm,
    PeopleList,
    SortList,
    SearchInput,
    TitleAdd,
  },
  props: {
    showProfile: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      sortCondition: {
        text: this.$t('peopleAside.sortAlphabetically'),
        value: 'byAlphabet',
      },
      sortVariants: [
        {
          text: this.$t('peopleAside.sortAlphabetically'),
          value: 'byAlphabet',
        },
        {
          text: this.$t('peopleAside.sortByDebtAmount'),
          value: 'byDebtSum',
        },
      ],
      filterCondition: {
        text: this.$t('peopleAside.filterAll'),
        value: 'All',
      },
      filterVariants: [
        {
          text: this.$t('peopleAside.filterAll'),
          value: 'All',
        },
        {
          text: this.$t('peopleAside.filterMyDebts'),
          value: 'iOweThem',
        },
        {
          text: this.$t('peopleAside.filterMyDebtors'),
          value: 'TheyOweMe',
        },
      ],
    };
  },
  watch: {
    locale() {
      this.sortVariants = [
        { text: this.$t('peopleAside.sortAlphabetically'), value: 'byAlphabet' },
        { text: this.$t('peopleAside.sortByDebtAmount'), value: 'byDebtSum' },
      ];
      this.filterVariants = [
        { text: this.$t('peopleAside.filterAll'), value: 'All' },
        { text: this.$t('peopleAside.filterMyDebts'), value: 'iOweThem' },
        { text: this.$t('peopleAside.filterMyDebtors'), value: 'TheyOweMe' },
      ];
      this.sortCondition = this.sortVariants
        .find((variant) => variant.value === this.sortCondition.value) || this.sortVariants[0];
      this.filterCondition = this.filterVariants
        .find((variant) => variant.value === this.filterCondition.value) || this.filterVariants[0];
    },
    sortCondition() {
      this.$store.commit(SET_PAYOUTS_ACTIVE_USER, this.filteredUsers[0]);
    },
    filterCondition() {
      this.$store.commit(SET_PAYOUTS_ACTIVE_USER, this.filteredUsers[0]);
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.app.currentLanguage,
      payouts: (state) => state.events.payouts.users,
      user: (state) => state.user.user,
      status: (state) => state.events.status,
      userPayoutsCurrency: (state) => state.events.userPayoutsCurrency || state.user.user.currency,
      activeUser: (state) => state.events.payoutsActiveUser,
    }),
    filteredUsers() {
      if (!this.payouts || !this.user) return [];
      let users = [];
      try {
        this.payouts.forEach((user) => {
          const userCopy = { ...user };
          const userName = this.$getUserName(userCopy);
          let { phone } = userCopy;

          phone = phone.replace(/\D/g, '').toLowerCase().trim();
          const searchName = this.searchText.toLowerCase().trim().replace(/\s$/, '');
          const searchNameList = [
            searchName, // original
            this.$cyrillicToTranslit.reverse(searchName), // to cyrillic
            this.$cyrillicToTranslit.transform(searchName), // to latin
          ];
          const isSearchNameMatch = searchNameList.some((item) => (
            userName.toLowerCase().indexOf(item) !== -1
          ));
          const searchPhone = this.searchText.replace(/[+()-\s]/g, '');
          if (userCopy && userName && isSearchNameMatch) {
            if (userName !== this.user.full_name) {
              users = users.filter((userInArray) => userInArray.uid !== userCopy.uid);
              users.push(userCopy);
            }
          } else if (/^\d+$/.test(searchPhone) && phone.indexOf(searchPhone) !== -1 && searchPhone !== '') {
            if (userName !== this.user.full_name) {
              users = users.filter((userInArray) => userInArray.uid !== userCopy.uid);
              users.push(userCopy);
            }
          }
        });
        if (!users || !users.length) return false;
        if (this.filterCondition.value === 'iOweThem') {
          users = users.filter((user) => +user.amount < 0);
        } else if (this.filterCondition.value === 'TheyOweMe') {
          users = users.filter((user) => +user.amount > 0);
        }
        if (this.sortCondition.value === 'byAlphabet') {
          users.sort((user1, user2) => {
            try {
              if (!this.$getUserName(user1)) return 1;
              if (!this.$getUserName(user2)) return -1;
              return this.$getUserName(user1).localeCompare(this.$getUserName(user2), ['en-GB', 'en-US', 'ru']);
            } catch (e) {
              return 1;
            }
          });
        } else if (this.sortCondition.value === 'byDebtSum') {
          users.sort((user1, user2) => {
            if (Math.abs(user1.amount) < Math.abs(user2.amount)) {
              return 1;
            }
            return -1;
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in userList: ', e.message);
      }
      if ((!this.activeUser || typeof this.activeUser.uid === 'undefined')
        && !!users.length
        && this.$route.params.uid === undefined) {
        this.$store.commit(SET_PAYOUTS_ACTIVE_USER, users[0]);
      }
      return users;
    },
  },
  methods: {
    selectUser(user) {
      if ((this.activeUser.uid !== user.uid) || (this.isMobile)) {
        this.$router.push({
          params: { uid: user.uid },
        });
      }
      if (this.isMobile) this.$emit('toggleShowProfile', user.uid);
      this.$refs.peopleSidebar.hide();
    },
    async deleteUser(user) {
      try {
        if (user.amount !== 0) return;
        await this.$store.dispatch(DELETE_USER_CONTACT_REQUEST, {
          contact: user,
        });
        await this.$store.dispatch(FETCH_USER_CONTACTS_REQUEST);
        if (this.isMobile) this.$emit('toggleShowProfile');
        if (this.$refs.peopleSidebar) this.$refs.peopleSidebar.hide();
        this.$router.replace({ path: '/people' });
        this.$store.commit(SET_PAYOUTS_ACTIVE_USER, this.filteredUsers[0]);
        await this.$store.dispatch(USER_PAYOUTS_REQUEST);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in deleting user: ', e.message);
      }
    },
    async confirmDeleteUser(user) {
      this.$store.commit(SET_CONFIRM_MODAL_INFO, {
        question: this.$t('CP.confirmDeleteContact'),
        acceptanceTitle: this.$t('CP.yesDelete'),
        denialTitle: this.$t('CP.cancel'),
        submitHandler: this.deleteUser.bind(this, user),
      });
      this.$bvModal.show('app-confirm-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
  .people-aside-container {
    flex: 0 0 372px;
    height: 100%;
    min-height: 100%;
  }
  .people-aside {
    height: 100%;
    min-height: 266px;
    box-sizing: border-box;
    padding: 20px 30px;
    position: relative;
    color: var(--text-main-color);
    background-color: var(--backgound-color);
    box-shadow: rgba(0, 76, 165, 0.16) 1px 1px 4px;
  }
  .people-aside_mobile {
    height: var(--height-full);
    min-height: 266px;
    box-sizing: border-box;
    padding: 20px 30px;
    position: relative;
    color: var(--text-main-color);
    background-color: var(--backgound-color);
    box-shadow: rgba(0, 76, 165, 0.16) 1px 1px 4px;
  }

  .people-list {
    max-height: calc(var(--height-full) - 146px);
    margin: 0 -5px;
    padding: 0 5px 20px;
    /*padding-bottom: 20px;*/
    /*margin: 0;*/
    min-height: 120px;
    overflow-y: auto;
  }

  .sort-list {
    height: 30px;
  }

  .people-aside__title-add {
    margin: 0 0 8px;
  }
  @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-lg) {
      .people-aside-container {
        flex: 0;
      }
        .people-aside {
        display: none;
      }
    }
    @media screen and (max-width: $breakpoint-sm) {
    .people-aside-container {
      flex: 1;
      height: unset;
    }
    .people-aside {
      height: unset;
      min-height: 100%;
    }
      .people-list {
      max-height: unset;
      min-height: 100%;
    }
  }
</style>
